import { render, staticRenderFns } from "./UciadultoView.vue?vue&type=template&id=2722f556"
import script from "./UciadultoView.vue?vue&type=script&lang=js"
export * from "./UciadultoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports